import { Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IBetslipRootState } from '../../../../../../base/store/state';
import { selectQuickDepositSelectedPaymentMethod } from '../../../../../quick-deposit/selector';

@Injectable({
    providedIn: 'root',
})
export class BetslipSelectedPaymentService {
    readonly selectedPayment$: Observable<string | undefined>;

    constructor(private store: Store<IBetslipRootState>) {
        this.selectedPayment$ = this.store.select(selectQuickDepositSelectedPaymentMethod);
    }
}
